import React from "react";
import { Modal, Button } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
const NonEligibilityCardDetailsModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      contentClassName="border-0 p-0 rounded-4 shadow-lg overflow-hidden"
    >
      <div
        style={{
          background:
            "linear-gradient(133deg, #41d3ffa5 0%, #7e42ffa0 47.4%, #dc3fffaf 96.19%)",
          color: "#fff",
          padding: "2rem 1rem",
          textAlign: "center",
          position: "relative",
        }}
      >
       <div
          className=" text-white position-absolute"
          style={{ right: "1rem", top: "0.6rem" ,cursor:'pointer' }}
          aria-label="Close"
          onClick={handleClose}
        >
          <RxCross2 size={18} />
        </div>
        <h2 className="fw-bold mb-2" style={{ fontSize: "1.5rem" }}>
          😔 Ohh! This One Wasn't For You
        </h2>
      </div>

      <Modal.Body className="text-center text-white p-4">
        <p className="mb-0 fs-6 text-white">
          You’re not eligible for this round of airdrop rewards. Don’t worry — new opportunities will be announced soon. ✨
        </p>

        <div
          style={{
            height: "2px",
            background: "linear-gradient(90deg, #6a11cb, #2575fc)",
            width: "80%",
            margin: "1rem auto",
            borderRadius: "2px",
          }}
        ></div>
      </Modal.Body>
    </Modal>
  );
};

export default NonEligibilityCardDetailsModal;
